module.exports = __webpack_public_path__ + "static/media/how-to-get-10k-instagram-followers.6566a292.md";